import { EMPLOYEES_BASE_QUERY_KEY } from "@/shared/configs/queryKeys";

export const EMPLOYEES_QUERY_KEYS = {
  all: EMPLOYEES_BASE_QUERY_KEY,

  // Infinite list queries (for paginated employee list)
  infinite: (queryString: string, sortParams: string[]) =>
    ["employees", "infinite", queryString || "all", JSON.stringify(sortParams)] as const,

  // Single employee
  details: () => [...EMPLOYEES_QUERY_KEYS.all, "detail"] as const,
  detail: (id: string) =>
    [...EMPLOYEES_QUERY_KEYS.details(), id] as const,
  // Own root, outside detail(id): the endpoint is costly, so unrelated detail
  // refreshes (attribute lock, IBAN) must not refetch it, while the "employees"
  // and "groups" central invalidations do (see shared/lib/cacheInvalidations.ts).
  dynamicUserGroups: (id: string) =>
    ["employee-dynamic-user-groups", id] as const,

  // IDs queries
  allIds: ["allEmployeesIds"] as const,
  filteredIds: (queryString: string) =>
    ["filteredEmployeesIds", queryString] as const,

  // Proof documents
  proofDocuments: {
    all: ["employee-proof-documents"] as const,
    list: (employeeId: string) =>
      ["employee-proof-documents", employeeId] as const,
    detail: (employeeId: string, proofDocumentId: string) =>
      ["employee-proof-documents", employeeId, proofDocumentId] as const,
  },

  // Employee beneficiaries (nested under employee)
  beneficiaries: {
    all: ["employee-beneficiaries"] as const,
    list: (employeeId: string) =>
      ["employee-beneficiaries", employeeId] as const,
    detail: (employeeId: string, beneficiaryId: string) =>
      ["employee-beneficiaries", employeeId, beneficiaryId] as const,
  },

  // Employee audit logs (history tab)
  auditLogs: {
    all: ["employee-audit-logs"] as const,
    infinite: (employeeId: string) =>
      ["employee-audit-logs", employeeId, "infinite"] as const,
  },

  // V2 proof documents (separate cache from legacy)
  proofDocumentsV2: {
    all: ["employee-proof-documents-v2"] as const,
    list: (employeeId: string) =>
      ["employee-proof-documents-v2", employeeId] as const,
  },

  // Aliases for backward compatibility with hooks
  proofDocumentsKeys: {
    all: ["employee-proof-documents"] as const,
    list: (employeeId: string) =>
      ["employee-proof-documents", employeeId] as const,
  },
} as const;
